<template>
    <div class="home-gate">
        <!-- Role not resolved yet (e.g. hard refresh: Firebase auth / the Vuex
             user doc hasn't finished loading). Render neither child until we
             actually know who's logged in -- guessing wrong here means a
             flash of the wrong dashboard, which is worse than a spinner. -->
        <div v-if="!roleResolved" class="home-gate-loading">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="40" :md-stroke="4" />
        </div>

        <AdminHome v-else-if="isAdmin" />
        <BulkClientHome v-else-if="isBulkClient" />
        <ClientHome v-else />
    </div>
</template>

<script>
// Adjust these two paths to wherever ClientHome/AdminHome actually live in
// your project -- I don't have those files, so I can't confirm the real
// path or their prop contracts (see chat).
import AdminHome from "./AdminHome.vue";
import ClientHome from "./ClientHome.vue";
import BulkClientHome from "./BulkClientHome.vue";
export default {
    name: "Home",
    components: {
        AdminHome,
        ClientHome,
        BulkClientHome
    },
    computed: {
        activeUser() {
            return this.$store.state.user;
        },

        // ASSUMPTION: the store's `user` starts out falsy/empty and only
        // gets populated once auth + the user doc have loaded, so "does it
        // have any keys yet" is a safe proxy for "role is known." If your
        // store instead seeds `user` as `{}` by design (so it's never
        // falsy) or exposes an explicit ready flag (e.g.
        // `this.$store.state.authReady` / a `userLoaded` getter), swap this
        // for that flag -- it'll be more reliable than inferring readiness
        // from object shape.
        roleResolved() {
            return !!(this.activeUser && Object.keys(this.activeUser).length);
        },

        // Same admin check the old combined Home.vue used: isAdmin or
        // isSuperAdmin -> AdminHome. Everything else (customerID or
        // clientID accounts) -> ClientHome. If there's a third bucket this
        // doesn't cover, this is the line to extend.
        isAdmin() {
            return !!(
                this.activeUser &&
                (this.activeUser.isAdmin || this.activeUser.isSuperAdmin)
            );
        },
         isBulkClient() {
            return !!(
                this.activeUser.clientID == "Costco"
            );
        }
    },
};
</script>

<style scoped>
.home-gate-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 240px;
}
</style>